import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-204" data-mp="21y3g8enwrjkj">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-line border-l-4 border-l-green bg-white p-4 pr-10 text-ink shadow-lift" aria-live="polite" data-id="element-205" data-mp="1wyh3s7fwm7cs">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow" aria-label="Cerrar aviso" data-id="element-206" data-mp="1sfeevfjhhfw4">
            <XIcon className="h-4 w-4" data-id="element-207" data-mp="1jhkm2ekxh4dp" />
          </button>
          <div className="flex gap-3" data-id="element-208" data-mp="1nfibniim1shm">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-green" aria-hidden="true" data-id="element-209" data-mp="1ninvojcdu46h" />
            <div data-id="element-210" data-mp="19nln1og5i0pz">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-greenDark" data-id="element-211" data-mp="1efv8osa8gemg">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-212" data-mp="zs0f79oei68b">
                Al completar tu compra recibes el
                <br data-id="element-213" data-mp="14rd9gfhlqfkx" />
                <span className="font-bold text-navy" data-id="element-214" data-mp="14qv7r3c6795m">{productName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-215" data-mp="qr2ilcgal0zr">Acceso digital inmediato por correo electrónico</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}